import { FC } from "react";

interface Props {
  id: "top" | "services" | "company" | "contact" | "values" | "features" | "case-study" | "contact-us" | "knowledge";
}

export const Anchor: FC<Props> = ({ id }) => {
  return <div id={id} className="relative top-[-120px] md:top-[-150px]" />;
};
